import { render, staticRenderFns } from "./MethodHeader.vue?vue&type=template&id=e2b4094a"
import script from "./MethodHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./MethodHeader.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./MethodHeader.vue?vue&type=style&index=0&id=e2b4094a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports